/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manager_Question_TitleInputs */



/**
* | output |
* | --- |
* | "Who is your manager?" |
*
* @param {Manager_Question_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manager_question_title = /** @type {((inputs?: Manager_Question_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manager_Question_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wie is je leidinggevende?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Qui est votre responsable ?")
	return /** @type {LocalizedString} */ ("Who is your manager?")
});